var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { FSWrapper } from 'cimpress-ui-reporting-helpers';
import { getGroupInfo, buildGroupUrlFromId } from 'coam-client';
import { useAsync } from 'react-async-hook';
const fetchReportingBlacklist = (accessToken, coamGroupId) => getGroupInfo(accessToken, buildGroupUrlFromId(coamGroupId))
    .then((group) => {
    return group.members.filter((m) => !m.is_client && m.profiles)
        .map((m) => m.profiles)
        .flat()
        .map((p) => p.user_id);
});
export const FullStory = ({ fsOptions, coamGroupId, blacklist, selector }) => {
    const { profile, accessToken } = useSelector(selector) || {};
    const fsWrapper = useRef(new FSWrapper(fsOptions));
    const isIdentified = useRef(false);
    const reportingBlacklist = useAsync(() => {
        if (coamGroupId) {
            return accessToken ?
                fetchReportingBlacklist(accessToken, coamGroupId)
                    .catch(() => []) :
                Promise.resolve([]);
        }
        return Promise.resolve(blacklist || []);
    }, [profile && profile.user_id, accessToken]);
    useEffect(() => {
        if (isIdentified.current) {
            isIdentified.current = false;
            fsWrapper.current.splitSession();
        }
        const runEffect = () => __awaiter(void 0, void 0, void 0, function* () {
            if (profile && !reportingBlacklist.loading) {
                if (yield fsWrapper.current.tryIdentifySession(profile, reportingBlacklist.result)) {
                    isIdentified.current = true;
                }
            }
        });
        runEffect();
    }, [profile, reportingBlacklist.loading, reportingBlacklist.result]);
    return null;
};
//# sourceMappingURL=FullStory.js.map